export default __webpack_public_path__ + "static/scam-latitude-protect-alert-2-8abe4afd7ab063c216f986de0f0c77f9.webp";